import React from "react";

const VoiceMailCallIcon = ({ width = 16, height = 16, color = "#5D60E7",className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_12323_100338)">
      <path
        d="M14.665 11.2827V13.2827C14.6657 13.4683 14.6277 13.6521 14.5533 13.8222C14.479 13.9924 14.3699 14.1451 14.233 14.2706C14.0962 14.3961 13.9347 14.4917 13.7588 14.5511C13.5829 14.6106 13.3966 14.6327 13.2117 14.616C11.1602 14.3931 9.18966 13.6921 7.45833 12.5693C5.84755 11.5458 4.48189 10.1801 3.45833 8.56934C2.33165 6.83014 1.63049 4.85 1.41166 2.78934C1.395 2.60498 1.41691 2.41918 1.47599 2.24375C1.53508 2.06833 1.63004 1.90713 1.75484 1.77042C1.87964 1.6337 2.03153 1.52448 2.20086 1.44968C2.37018 1.37489 2.55322 1.33618 2.73833 1.336H4.73833C5.06187 1.33282 5.37552 1.44739 5.62084 1.65836C5.86615 1.86933 6.02638 2.1623 6.07166 2.48267C6.15608 3.12271 6.31263 3.75115 6.53833 4.356C6.62802 4.59462 6.64744 4.85395 6.59427 5.10326C6.5411 5.35257 6.41757 5.58141 6.23833 5.76267L5.39166 6.60934C6.3407 8.27837 7.72263 9.6603 9.39166 10.6093L10.2383 9.76267C10.4196 9.58343 10.6484 9.4599 10.8977 9.40673C11.1471 9.35356 11.4064 9.37297 11.645 9.46267C12.2498 9.68837 12.8783 9.84492 13.5183 9.92934C13.8422 9.97502 14.1379 10.1381 14.3494 10.3877C14.5608 10.6372 14.6731 10.9557 14.665 11.2827Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2314 3.90039C15.1228 3.9005 15.8496 4.6166 15.8496 5.5C15.8496 6.34368 15.1866 7.03216 14.3506 7.09277V7.09961H10.3994V7.09277C9.5634 7.03216 8.90039 6.34368 8.90039 5.5C8.90039 4.6166 9.62719 3.9005 10.5186 3.90039C11.41 3.90039 12.1377 4.61654 12.1377 5.5C12.1377 5.81952 12.0407 6.11637 11.877 6.36621H12.873C12.7093 6.11637 12.6123 5.81952 12.6123 5.5C12.6123 4.61654 13.34 3.90039 14.2314 3.90039ZM10.5186 4.63379C10.033 4.63389 9.63965 5.02346 9.63965 5.5C9.63965 5.97654 10.033 6.36611 10.5186 6.36621C11.0042 6.36621 11.3975 5.9766 11.3975 5.5C11.3975 5.0234 11.0042 4.63379 10.5186 4.63379ZM14.2314 4.63379C13.7458 4.63379 13.3525 5.0234 13.3525 5.5C13.3525 5.9766 13.7458 6.36621 14.2314 6.36621C14.717 6.36611 15.1104 5.97654 15.1104 5.5C15.1104 5.02346 14.717 4.63389 14.2314 4.63379Z"
        fill={color}
        stroke={color}
        strokeWidth="0.2"
      />
    </g>
    <defs>
      <clipPath id="clip0_12323_100338">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default VoiceMailCallIcon;
